import Vue from 'vue'
import elementLocale from 'element-ui/lib/locale'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import en from 'element-ui/lib/locale/lang/en'
import messages from './en.json'
import { getSystemLanguage, resolveLanguage } from './locale'

const state = Vue.observable({ locale: resolveLanguage('en', getSystemLanguage()) })
const cache = new Map()
const hasMessage = key => Object.prototype.hasOwnProperty.call(messages, key)
const patterns = Object.keys(messages).filter(key => /\{\d+\}/.test(key)).map(key => {
  const names = []
  const source = key.split(/(\{\d+\})/).map(part => {
    if (/^\{\d+\}$/.test(part)) {
      names.push(part.slice(1, -1))
      return '([\\s\\S]*?)'
    }
    return part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  }).join('')
  return { key, names, regex: new RegExp(`^${source}$`) }
})

function interpolate (message, params) {
  return message.replace(/\{(\w+)\}/g, (placeholder, key) => Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : placeholder)
}

// 仅在显示入口调用；不改写业务记录、选择值、权限码和协议数据。
export function t (value, params) {
  if (Array.isArray(value)) return value.map(item => t(item))
  if (typeof value !== 'string') return value
  if (state.locale === 'zh-CN') return params ? interpolate(value, params) : value
  let translated = hasMessage(value) ? messages[value] : undefined
  if (translated === undefined) {
    const trimmed = value.trim()
    if (hasMessage(trimmed)) translated = value.replace(trimmed, messages[trimmed])
  }
  if (translated !== undefined) return params ? interpolate(translated, params) : translated
  if (!/[\u3400-\u9fff]/.test(value)) return value
  if (cache.has(value)) return cache.get(value)
  for (const pattern of patterns) {
    const match = pattern.regex.exec(value)
    if (!match) continue
    const values = {}
    pattern.names.forEach((name, index) => { values[name] = match[index + 1] })
    translated = interpolate(messages[pattern.key], values)
    if (cache.size >= 1000) cache.clear()
    cache.set(value, translated)
    return translated
  }
  return value
}

export function getLocale () {
  return state.locale
}

export function setLanguage (preference) {
  state.locale = resolveLanguage(preference, getSystemLanguage())
  elementLocale.use(state.locale === 'zh-CN' ? zh : en)
  if (typeof document !== 'undefined') document.documentElement.lang = state.locale
}

export default {
  install (Vue) {
    Vue.prototype.$t = t
    Object.defineProperty(Vue.prototype, '$locale', { get: getLocale })
    // Element 的日期、分页等组件也依赖同一响应式语言，切换后无需重挂业务页面。
    elementLocale.i18n((key, options) => {
      const pack = state.locale === 'zh-CN' ? zh : en
      const value = key.split('.').reduce((result, part) => result && result[part], pack)
      return typeof value === 'string' ? interpolate(value, options || {}) : value
    })
  }
}
